import nightlife from "../../assets/nightlife.jpg";
import personal from "../../assets/personal.jpg";
//import notes from "../../assets/notes.jpg";
//import quiz from "../../assets/quiz.jpg";
import photo from "../../assets/photo.jpg";
//import market from "../../assets/market.jpg";
import thrift from "../../assets/thriftshop.jpg";

export const projectsData = [
  {
    id: 1,
    image: thrift,
    url: "https://the-daily-drip.netlify.app/",
    title: "Thrift Shop",
    category: "web",
  },
  {
    id: 2,
    image: personal,
    url: "https://sam-debugged.netlify.app/",
    title: "Personal Blog",
    category: "web",
  },
  {
    id: 3,
    image: nightlife,
    url: "https://belawinskibar.netlify.app/",
    title: "Entertainment",
    category: "web",
  },
  {
    id: 4,
    image: photo,
    url: "https://pichaview.netlify.app/",
    title: "PichaView",
    category: "web",
  },
  // {
  //   id: 4,
  //   image: market,
  //   url: "https://kemonkmarketplace.netlify.app/",
  //   title: "MarketPlace",
  //   category: "web",
  // },
  // {
  //   id: 5,
  //   image: quiz,
  //   url: "https://samsmindsprint.netlify.app/",
  //   title: "Quiz App",
  //   category: "web",
  // },
  // {
  //   id: 6,
  //   image: notes,
  //   url: "https://my-notevault.netlify.app/",
  //   title: "Notes Vault",
  //   category: "web",
  // },
];

export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "web",
  },
  {
    name: "app",
  },
  {
    name: "design",
  },
];
